export default class Fitting {
    constructor(fitting) {
        this.id = fitting.id;
        this.product_id = fitting.product_id;
        this.field = fitting.field;
        this.quantity = fitting.quantity;
        this.created_at = fitting.created_at;
        this.updated_at = fitting.updated_at;
        this.code1 = fitting.fitting.code1;
        this.code2 = fitting.fitting.code2;
        this.description = fitting.fitting.description;
        this.bold = fitting.fitting.bold;
        this.type = fitting.fitting.type;
        this.company_id = fitting.fitting.company_id;

    }
}